import formatIsoDate from '@/services/general/formatIsoDate';

export default function checkPeriodeAndFormat(critere, name) {
  if (critere[name]) {
    if (!critere[name].dateDebut && !critere[name].dateFin) {
      delete critere[name];
    } else {
      critere[name].dateDebut = formatIsoDate(critere[name].dateDebut);
      critere[name].dateFin = formatIsoDate(critere[name].dateFin);
    }
  }
}
